import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { XCircle } from 'lucide-react';

const PagoCanceladoPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md" data-testid="pago-cancelado-page">
        <CardContent className="p-8 text-center">
          <XCircle className="h-16 w-16 text-zinc-400 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-foreground mb-2">Pago cancelado</h1>
          <p className="text-muted-foreground mb-6">
            No te preocupes, no se ha realizado ningún cobro. Puedes volver a intentarlo cuando quieras.
          </p>
          <div className="space-y-2">
            <Button className="w-full" onClick={() => navigate('/pricing')}>Ver planes de nuevo</Button>
            <Button variant="outline" className="w-full" onClick={() => navigate('/portal')}>Volver a mi cuenta</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PagoCanceladoPage;
